// export const URL = "http://localhost:8000/";
// export const THIS_URL = "http://localhost:3000/";

export const URL = "https://api.renatatrinca.com.br/"
export const THIS_URL = "https://www.renatatrinca.com.br/"
export const DEBUG=false;
// export const URL = "https://rttesteapi.enterscience.com.br/"
// export const THIS_URL = "https://rtteste.enterscience.com.br/"

export const API_URL = URL + "api/";
export const STORAGE_URL = URL + "storage/";
export const STORAGE_URL_PROTECTED = URL + "files/";


//KEYS PARA BUSCAR OS ESTILOS DAS PÁGINAS

export const PAGE_KEYS = {
  header: "header",
  login: "login",
  register: "register",
  landing: "landing",
  mural_cursos: "mural_cursos",
};
